/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Improve_Body_2Inputs */

const en_how_we_work_improve_body_2 = /** @type {(inputs: How_We_Work_Improve_Body_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When the first phase earns its place, we plan the next one: more tasks, more agents or the next part of the system.`)
};

const lv_how_we_work_improve_body_2 = /** @type {(inputs: How_We_Work_Improve_Body_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kad pirmais posms sevi attaisno, plānojam nākamo: vairāk uzdevumu, vairāk aģentu vai nākamo sistēmas daļu.`)
};

/**
* | output |
* | --- |
* | "When the first phase earns its place, we plan the next one: more tasks, more agents or the next part of the system." |
*
* @param {How_We_Work_Improve_Body_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_improve_body_2 = /** @type {((inputs?: How_We_Work_Improve_Body_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Improve_Body_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_improve_body_2(inputs)
	return en_how_we_work_improve_body_2(inputs)
});